import { Component, Field } from '@contember/interface'

export const ReviewsPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
